import { func } from 'prop-types';
import React from 'react';

import Button from '../../components/Button';

import s from './index.module.css';

const Footer = ({ onBtnClick }) => {
  return (
    <section className={s.footerSection}>
      <h2 className={s.footerHeader}>Удаленная работа для экспертов в&nbsp;запчастях</h2>
      <div className={s.footerContent}>
        <p className={s.info}>
          Помогайте клиентам в чате подбирать запчасти и получайте вознаграждение до&nbsp;3% от стоимости заказа.
          В удобное для вас время с вознаграждением каждые две недели
        </p>
        <Button className={s.submitBtn} type="button" onClick={onBtnClick}>Начать зарабатывать</Button>
      </div>
    </section>
  );
}

Footer.propTypes = {
  onBtnClick: func,
};

Footer.defaultProps = {
  onBtnClick: () => {},
};

export default Footer;


